var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"outlined":"","color":"primary"}},[_vm._v(" Sinc. Calendário ")])
}
var staticRenderFns = []

export { render, staticRenderFns }